import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import {
  buildSearchQuery,
  comboboxValue,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";
import { DataColumn } from "../controls/Data.default";

// ── Columns per level ────────────────────────────────────────────────────────

export const roadmapColumns: DataColumn[] = [
  { title: "Name", key: "name", width: 224, sort: true, defaultSort: "asc", fixed: "left" },
  {
    title: "Active",
    key: "isActive",
    width: 96,
    sort: true,
    transform: (value) => (value ? "Active" : "—"),
  },
  { title: "Short Description", key: "shortDescription", width: 288, sort: true },
  { title: "Stages", key: "stagesCount", width: 112, sort: true, type: "badge" },
  { title: "Companies", key: "companiesCount", width: 128, sort: true, type: "badge" },
  { title: "Created On", key: "createdOn", width: 160, format: "DD/MM/YYYY", sort: true },
];

// The flat Assignments grid (across all roadmaps) — adds a Roadmap column to the company view.
export const assignmentColumns: DataColumn[] = [
  { title: "Roadmap", key: "roadmapName", width: 208, sort: true, defaultSort: "asc", fixed: "left" },
  { title: "Company", key: "companyName", width: 208, sort: true, fixed: "left" },
  { title: "Current Stage", key: "currentStage", width: 128, sort: true, type: "badge" },
  { title: "Current Requirement", key: "currentRequirement", width: 160, sort: true, type: "badge" },
  { title: "Assigned On", key: "createdOn", width: 160, format: "DD/MM/YYYY", sort: true },
];

// ── Filter query-mappers per level ───────────────────────────────────────────

const nameMappings: QueryFieldMapping[] = [{ formField: "name" }];
export const mapNameQuery = (values: any): SearchQuery =>
  buildSearchQuery(values, nameMappings);

// Assignments filter: by roadmap and/or company (independent comboboxes).
const assignmentMappings: QueryFieldMapping[] = [
  { formField: "roadmap", queryField: "roadmapUid", operation: QueryOperation.Equal, transform: comboboxValue },
  { formField: "company", queryField: "companyUid", operation: QueryOperation.Equal, transform: comboboxValue },
];
export const mapAssignmentQuery = (values: any): SearchQuery =>
  buildSearchQuery(values, assignmentMappings);

// Re-export for the request builder so it doesn't import QueryOperation twice.
export { QueryOperation };
